import { type ReactElement, useCallback, useState } from 'react';
import styles from './styles.module.scss';

interface TabDefinition {
  component: ReactElement;
  name: string;
}

interface TabsProps {
  tabs: Record<string, TabDefinition>;
  onActiveTabChanged?: (tab: string) => void;
  initialTab?: string;
  disabled?: boolean;
}

function Tabs(props: TabsProps) {
  const { tabs, onActiveTabChanged = undefined, initialTab = '', disabled = false } = props;
  const [activeTab, setActiveTab] = useState(
    initialTab && tabs[initialTab] ? initialTab : (Object.keys(tabs)[0] ?? ''),
  );

  const handleTabSelected = useCallback(
    (tab: string) => {
      setActiveTab(tab);
      onActiveTabChanged?.(tab);
    },
    [onActiveTabChanged],
  );

  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabHeaderWrapper}>
        {Object.entries(tabs).map(([key, { name }]) => (
          <button
            key={key}
            onClick={() => handleTabSelected(key)}
            className={`${styles.tabHeader} ${key === activeTab && styles.active}`}
            disabled={disabled}
          >
            {name}
          </button>
        ))}
      </div>
      <div>{tabs[activeTab]?.component}</div>
    </div>
  );
}

export default Tabs;
